import { useEnrollmentStore } from '@/stores'
import { readWidgetLeadData } from '../state/widgetLeadStorage'
import {
  getEnrollmentDraftFirstName,
  getEnrollmentDraftLocationExternalId,
  getEnrollmentDraftLocationState,
  getEnrollmentDraftProgramExternalId,
  getEnrollmentDraftRecord,
  getEnrollmentDraftZipCode
} from './enrollmentDraftSelectors'

export type EnrollmentDraftRecord = Record<string, string>
type EnrollmentDraftLike = Partial<{
  locationExternalId: string
  programExternalId: string
  zipCode: string
}>

export function getStoredEnrollmentDraftRecord(): EnrollmentDraftRecord {
  return getEnrollmentDraftRecord()
}

export function getStoredDraftLocationExternalId(
  storedDraft: EnrollmentDraftLike = getStoredEnrollmentDraftRecord()
) {
  return getEnrollmentDraftLocationExternalId(storedDraft)
}

export function getStoredDraftProgramExternalId(
  storedDraft: EnrollmentDraftLike = getStoredEnrollmentDraftRecord()
) {
  return getEnrollmentDraftProgramExternalId(storedDraft)
}

export function getStoredDraftZipCode(storedDraft: EnrollmentDraftLike = getStoredEnrollmentDraftRecord()) {
  return getEnrollmentDraftZipCode(storedDraft)
}

export function getStoredEnrollmentSessionToken(storedSessionToken?: string | null) {
  return storedSessionToken?.trim() ?? ''
}

export function getStoredEnrollmentLocationState(storedLocationState?: string | null) {
  return storedLocationState || getEnrollmentDraftLocationState()
}

export function getStoredEnrollmentFirstName(storedFirstName?: string | null) {
  return storedFirstName || getEnrollmentDraftFirstName()
}

export function getStoredEnrollmentZipCodeWithProfileFallback() {
  const draftZip = getEnrollmentDraftZipCode()
  if (draftZip) return draftZip

  const profileZip = useEnrollmentStore.getState().userProfile?.personalData?.zipCode?.trim()
  if (profileZip) return profileZip

  return ''
}

export function getStoredEnrollmentLeadContactData() {
  const storedDraft = getStoredEnrollmentDraftRecord()
  const widgetLead = readWidgetLeadData()
  const merged = { ...storedDraft }

  if (widgetLead.firstName) merged.firstName = widgetLead.firstName
  if (widgetLead.lastName) merged.lastName = widgetLead.lastName
  if (widgetLead.email) merged.email = widgetLead.email
  if (widgetLead.phone) merged.phone = widgetLead.phone

  return merged
}
